import { render, staticRenderFns } from "./CompanyReportingTable.vue?vue&type=template&id=8c6a5d48&scoped=true"
import script from "./CompanyReportingTable.vue?vue&type=script&lang=js"
export * from "./CompanyReportingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a5d48",
  null
  
)

export default component.exports